import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { ChipItem, CustomChipComponent } from 'src/app/custom-chip/custom-chip.component';
import { HireSuggestionsListComponent } from 'src/app/hire-person-search/hire-suggestions-list/hire-suggestions-list.component';
import { FilterStoreService } from 'src/app/hire-person-search/store/filter-store.service';
import cjson from 'compressed-json';
import { FilterResponseMapperServiceService } from 'src/app/hire-person-search/filter-response-mapper-service.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { OpenaiService } from 'src/app/openai/openai.service';
import { RequestServiceService } from 'src/app/hire-person-search/request-service.service';
import * as _ from 'underscore';


interface SuggestionPayload {
  [field: string]: any; // replace with your actual response shape
}

@Component({
  selector: 'app-hire-quick-search',
  imports: [CustomChipComponent, MatAutocompleteModule, ReactiveFormsModule, HireSuggestionsListComponent, CommonModule, MatTooltipModule, NgbTooltipModule],
  templateUrl: './hire-quick-search.component.html',
  styleUrl: './hire-quick-search.component.scss',
  standalone: true
})
export class HireQuickSearchComponent {

  jobTitleControl: FormControl = new FormControl('');
  private typeAheadSubject = new Subject<{ event: Event; type: string }>();
  private subscriptions: Subscription[] = [];
  private typeaheadSubscription: Subscription | null = null;
  jobTitleList: any[] = [];
  jobTitleSelectedList: ChipItem[] = [];
  skillsControl: FormControl = new FormControl('');
  skillsList: any[] = [];
  skillsSelectedList: ChipItem[] = [];
  locationControl: FormControl = new FormControl('');
  locationList: any[] = [];
  locationSelectedList: ChipItem[] = [];
  hasEuAccess: any = null;
  defaultContinents: any = null;
  private cachedSuggestionPayload: SuggestionPayload | null = null;

  // Set to true whenever a selection changes; cleared after API #1 completes
  private suggestionPayloadStale = false;

  // Prevents concurrent API #1 calls
  private isFetchingPayload = false;
  fieldSuggestions: any[] = [];
  booleanQuery: string = '';
  keywordInputControl: FormControl = new FormControl('');
  isEditing: boolean = false;
  locationContinents: any[] = [];
  continentstobeincluded: any[] = [];


  constructor(private personSearchService: PersonSearchService, private router: Router, private modalService: NgbModal, private filterStoreService: FilterStoreService,
        private filtermapperService: FilterResponseMapperServiceService, private localStorageService: LocalStorageService, private openaiService: OpenaiService,
    private requestService: RequestServiceService,


  ) { }

  ngOnInit() {
    const typeaheadSub = this.typeAheadSubject
      .pipe(debounceTime(500))
      .subscribe(({ event, type }) => this.callTypeAheadSearch(event, type));

    this.subscriptions.push(typeaheadSub);
    this.hasEuAccess = this.localStorageService.getItem('hasEUTalentInsightsAccess');
    this.defaultContinents = this.localStorageService.getItem('defaultContinent');


  }

  searchSuggestions(event: any, type: string) {
    this.typeAheadSubject.next({ event, type });

  }

  callTypeAheadSearch(event: any, type: string) {
    const query = event.target.value;
    switch (type) {
      case 'jobtitle': {
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'jobtitle')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.jobTitleList = response.data;
            }
          });
        break;
      }
      case 'skills': {
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'skills')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.skillsList = response.data;
            }
          });
        break;
      }
      case 'location': {
        this.typeaheadSubscription?.unsubscribe();
        this.typeaheadSubscription = this.personSearchService
          .getPersonSearchListing(query, 'location')
          .subscribe((response: any) => {
            if (response.status === 'success' && response.data) {
              this.locationList = response.data;
              // Handle location suggestions here
            }
          });
          break;
    }
  }
  }

  selectedItem(event: any, type: string, keyboardEvent?: string) {
     const value = keyboardEvent == 'enterSuggestions' ? event: (keyboardEvent == 'enter') ? event.target.value : keyboardEvent == 'aisuggestion' ? event : event.option.value;
        if (!value) return;
        const chipItem: ChipItem = {
          key: (keyboardEvent == 'enter') ? value + ".searchastext" : keyboardEvent == 'aisuggestion' ? value.key + ".aisearch" :  keyboardEvent == 'enterSuggestions' ? value.key + ".searchastext": value.key,
          chipkey: (keyboardEvent == 'enter') ? value : keyboardEvent == 'enterSuggestions' ?  value.key: value.key,
          isExcluded: false,
          isSuggested: keyboardEvent == 'aisuggestion' ? true : false,
        };

        if (type === 'jobtitle') {
          const alreadyAdded = this.jobTitleSelectedList.some((c) => c.key === chipItem.key);
          if (!alreadyAdded) {
            this.jobTitleSelectedList = [...this.jobTitleSelectedList, chipItem];
          }
          this.jobTitleControl.setValue('');
          this.jobTitleList = [];
        }  if (type === 'jobtitle') {
          const alreadyAdded = this.jobTitleSelectedList.some((c) => c.key === chipItem.key);
          if (!alreadyAdded) {
            this.jobTitleSelectedList = [...this.jobTitleSelectedList, chipItem];
          }
          this.jobTitleControl.setValue('');
          this.jobTitleList = [];
        }  if (type === 'skills') {
          const alreadyAdded = this.skillsSelectedList.some((c) => c.key === chipItem.key);
          if (!alreadyAdded) {
            this.skillsSelectedList = [...this.skillsSelectedList, chipItem];
          }
          this.skillsControl.setValue('');
          this.skillsList = [];
        } if (type === 'location') {
          const alreadyAdded = this.locationSelectedList.some((c) => c.key === chipItem.key);
          if (!alreadyAdded) {
            this.locationSelectedList = [...this.locationSelectedList, chipItem];
          }
          this.locationControl.setValue('');
          this.locationList = [];
        } if (type == 'booleansearch') {
      this.booleanQuery = this.keywordInputControl.value;
      this.isEditing = false;
    }
  if ((type === 'jobtitle' || type === 'pastjobtitle' || type === 'skills' || type === 'booleansearch')) {
      this.invalidateAndRefetch(type);
    }

  }

  redirectToInsightsDetails() {
    this.syncFilter();
    this.modalService.dismissAll();
      const filter = this.filterStoreService.getFilters();

      const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filter)));
      localStorage.setItem(localKey, JSON.stringify(cjson.compress(filter)));
      this.router.navigate(
        ['/talent-insights/overview'],
        {
          queryParams: {
            key: encodeURIComponent(localKey)
          },
        }
      );
  }

  syncFilter() {
    this.filterStoreService.setFilter({ jobTitleSelectedList: this.jobTitleSelectedList });
    this.filterStoreService.setFilter({ skillsSelectedList: this.skillsSelectedList });
    this.filterStoreService.setFilter({ locationSelectedList: this.locationSelectedList });
    this.filterStoreService.setFilter({ booleanquery: this.keywordInputControl.value });
  }

    isLocationDisabled(location: any): boolean {
    if (this.filtermapperService.isHireSearchListing) {
      return this.hasEuAccess != 1 && location?.location_continent?.toLowerCase() === 'europe';
    }
    return false;
  }

  getTooltipText(location: any): string {
    if (this.isLocationDisabled(location)) {
      return 'This location cannot be selected due to GDPR regulations.\n As part of our commitment to EU data protection regulations, candidate personal data (PII) is not displayed or processed for EU-based profiles.';
    } else {
      return `${this.capitalizeFirst(location?.value)} | ${this.capitalizeFirst(location?.location_type)}`;
    }
  }

  capitalizeFirst(value: string): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  private invalidateAndRefetch(changedField: string) {
    this.suggestionPayloadStale = true;

    if (this.isFetchingPayload) return;

    this.isFetchingPayload = true;
    const payload = this.buildSuggestionRequestPayload();

    this.openaiService.getJobTitleAndSkillSuggestions(payload).subscribe({
      next: (response: any) => {
        this.isFetchingPayload = false;
        if (response.status === 'success' && response.data) {
          // Cache the result from API #1
          this.cachedSuggestionPayload = response.data;
          this.suggestionPayloadStale = false;

          // Now call API #2 for the specific field that triggered this
          this.fetchFieldSuggestions(changedField);
        }
      },
      error: () => {
        this.isFetchingPayload = false;
      },
    });
  }

    /**
   * Reads current selected lists and builds the payload for API #1.
   */
  private buildSuggestionRequestPayload() {
    const titles = this.jobTitleSelectedList
      .filter((jt) => !jt.isSuggestion)
      .map((jt) => jt.key.replace('.searchastext', ''));



    const skills = this.skillsSelectedList
      .filter((s) => !s.isSuggestion)
      .map((s) => s.key.replace('.searchastext', ''));

    return {
     boolean: this.booleanQuery || null,
      jobtitles: [...titles],
      skills,
    };
  }

    private fetchFieldSuggestions(field: string) {
      const payload = this.requestService.getHireRequestWithFilters();
      if (this.cachedSuggestionPayload) {
        payload.jobtitles = this.cachedSuggestionPayload.suggestedjobtitles;
        payload.preferredskills = this.cachedSuggestionPayload.suggestedskills;
      }
     if (field == 'location') {
        payload.aggregatetype = 'location_name-location_continent';
      } else {
        payload.aggregatetype = field;

      }
      this.personSearchService.getTotalAggs(payload).subscribe({
        next: (response: any) => {
          if (response.status === 'success' && response.data) {
            // Store suggestions per field so the template can show them
            this.fieldSuggestions[field] = field == 'location' ? response.data.aggregations['location_name-location_continent'] : response.data.aggregations[field];
            this.getFieldSuggestions(field);

          }
        },
        error: (err) => {
          console.error(`Field suggestion error for "${field}":`, err);
        },
      });
    }

     getFieldSuggestions(field: string) {
    switch (field) {
      case 'jobtitle':
        const existingSuggestions = this.jobTitleSelectedList;
        const newSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newSuggestions.slice(0, 5);
        break;// limit to top 5 suggestions
         case 'skills':
        const existingSkillsSuggestions = this.skillsSelectedList;
        const newSkillsSuggestions = this.fieldSuggestions[field].filter(suggestion => !existingSkillsSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.key));
        this.fieldSuggestions[field] = newSkillsSuggestions.slice(0, 5);
        break;
    }
  }

    showAiSuggestionsFor(field: string): boolean {
    const config = this.aiSuggestionFields[field];
    if (!config) {
      return false;
    }
    const hasFieldData = this.hasValue(config.control.value) || (config.selectedList()?.length ?? 0) > 0;
    return hasFieldData || this.hasValue(this.booleanQuery);
  }
    /** True if a form control value is non-null/undefined/empty-string (usable from templates too) */
  hasValue(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
  }

  /**
   * AI Suggestions should only ever appear for Job Title, Past Job Title and Skills,
   * and only once there is data in that specific field — either text currently typed
   * into the input, OR a chip already selected for it — OR in the boolean/keyword search.
   */
  private readonly aiSuggestionFields: Record<string, { control: FormControl; selectedList: () => ChipItem[] }> = {
    jobtitle: { control: this.jobTitleControl, selectedList: () => this.jobTitleSelectedList },
    skills: { control: this.skillsControl, selectedList: () => this.skillsSelectedList },
  };

   removeChip(chip: ChipItem, type: string) {
      switch (type) {
        case 'jobtitle':
          this.jobTitleSelectedList = this.jobTitleSelectedList.filter((c) => c.key !== chip.key);
          break;
        case 'skills':
          this.skillsSelectedList = this.skillsSelectedList.filter((c) => c.key !== chip.key);
          break;
        case 'location':
                this.locationSelectedList = this.locationSelectedList.filter((c) => c.key !== chip.key);
                this.locationContinents = this.locationContinents.filter((c) => c.key !== chip.key);
                this.continentstobeincluded = _.pluck(this.locationContinents, 'continent');
                break;
      }
          if (this.jobTitleSelectedList?.length == 0 && this.skillsSelectedList?.length == 0) {
      this.cachedSuggestionPayload = null;


    }
    if (this.jobTitleSelectedList?.length > 0 || this.skillsSelectedList?.length > 0) {
      this.invalidateAndRefetch(type);
    }
    }

      /** Public entry point: clears just ONE field and recalculates the count. Called from each field's "Clear" link. */
  clearIndividualFilter(field: string): void {
    this.clearFieldValues(field);
  }

    private clearFieldValues(field: string): void {
    switch (field) {
      case 'jobtitle':
        this.jobTitleControl.setValue('');
        this.jobTitleSelectedList = [];
        this.jobTitleList = [];
        if (!this.skillsSelectedList?.length) {
          this.cachedSuggestionPayload = null;
        }
        break;


      case 'skills':
        this.skillsControl.setValue('');
        this.skillsSelectedList = [];
        this.skillsList = [];
        if (!this.jobTitleSelectedList?.length) {
          this.cachedSuggestionPayload = null;
        }
        break;

      case 'location':
        this.locationControl.setValue('');
        this.locationSelectedList = [];
        this.locationList = [];
        this.locationContinents = [];
        this.continentstobeincluded = [];
        break;

      case 'booleansearch':
        this.keywordInputControl.setValue('');
        this.booleanQuery = '';
        break;
    }
  }

  dismiss() {
    this.modalService.dismissAll();
  }

}
